export * from './img.interface';
export * from './info.interface';
export * from './style-definition.interface';
export * from './content-definition.interface';
export * from './create-pdf.interface';
export * from './text.interface';
export * from './columns.interface';
export * from './table';
export * from './stack.interface';
export * from './qr.interface';
export * from './toc/toc.interface';
export * from './toc/toc-item.interface';
export * from './text-reference.interface';
export * from './page-reference.interface';
export * from './list/unordered-list.interface';
export * from './list/ordered-list.interface';
export * from './list/list.interface';
export * from './list/item.interface';
export * from './fonts/font-types.interface';
export * from './fonts/font-type-configuration.interface';
export * from './fonts/fonts.interface';
export * from './fonts/use-font.interface';
export * from './vector/vector.interface';
export * from './vector/rect.interface';
export * from './vector/line.interface';
export * from './vector/ellipse.interface';
export * from './vector/polyline.interface';
export * from './vector/canvas.interface';
export * from './svg.interface';
export * from './permissions.interface';
export * from './custom-page-size.interface';
export * from './document-node.interface';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/index.js
// module id = 1173
// module chunks = 4